import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitPascal',
})
export class SplitPascalPipe implements PipeTransform {
  transform(word: string): string {
    if (!word) return '';

    // This regex matches:
    // 1. A sequence of uppercase letters followed by a lowercase one (e.g., "RDUsers" -> "RD Users")
    // 2. A lowercase letter followed by an uppercase one (e.g., "CamelCase" -> "Camel Case")
    return word
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // Splits acronyms from subsequent words
      .replace(/([a-z])([A-Z])/g, '$1 $2');     // Splits standard PascalCase/camelCase
  }
}
